import React from "react";
import { StatusBadge } from "./Shared";
import { formatDate } from "./utils";

const UserGroupModal = ({ open, title, users, onClose }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4 overflow-y-auto">
            <div className="w-full max-w-4xl max-h-[85vh] overflow-y-auto rounded-xl bg-white border border-slate-200 p-6" style={{ boxShadow: "0 10px 30px rgba(0,0,0,0.15)" }}>
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-bold text-slate-800">{title}</h2>
                    <button onClick={onClose} className="text-slate-400 hover:text-slate-600">✕</button>
                </div>

                <div className="overflow-x-auto">
                    <table className="min-w-full text-sm">
                        <thead style={{ background: "#f8fafc" }}>
                            <tr>
                                <th className="p-2 text-left text-xs text-slate-500">Company</th>
                                <th className="p-2 text-left text-xs text-slate-500">User ID</th>
                                <th className="p-2 text-left text-xs text-slate-500">Server</th>
                                <th className="p-2 text-left text-xs text-slate-500">Provider</th>
                                <th className="p-2 text-center text-xs text-slate-500">Status</th>
                                <th className="p-2 text-center text-xs text-slate-500">Expire Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.length === 0 ? (
                                <tr><td colSpan={6} className="p-6 text-center text-slate-400 text-sm">No users in this group.</td></tr>
                            ) : (
                                users.map((u) => (
                                    <tr key={u.slNo} className="border-t border-slate-100">
                                        <td className="p-2 text-xs text-slate-800">{u.company_name}</td>
                                        <td className="p-2 text-xs text-slate-500">{u.user_id}</td>
                                        <td className="p-2 text-xs text-slate-500">{u.server_name} ({u.server_port})</td>
                                        <td className="p-2 text-xs text-slate-500">{u.provider_name || "—"}</td>
                                        <td className="p-2 text-center"><StatusBadge status={u.status} /></td>
                                        <td className="p-2 text-center text-xs text-slate-500">{formatDate(u.expire_date)}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default UserGroupModal;
